import React from "react";
import { Grid } from "@material-ui/core";
import {
  GetDateString,
  exudate,
  calculatePushScore,
} from "../../../General/common";
import moment from "moment";

export const WithGroupedWoundReports = ({ woundEvaluation, children }) => {
  const orientationEnum = {
    LEFT: 2,
    RIGHT: 1,
  };

  const acquisitionEnum = {
    1: "Admitted",
    2: "Acquired",
    3: "Closed",
    4: "Reoccuring",
  };

  const getHorizontalOrientation = (orientation) => {
    switch (orientation) {
      case orientationEnum.LEFT:
        return "Left - ";
      case orientationEnum.RIGHT:
        return "Right - ";
      default:
        return "";
    }
  };

  return (
    <>
      {woundEvaluation?.map(
        ({
          woundType,
          facilityName,
          toDate,
          fromDate,
          woundEvaluationDetail,
        }) => {
          return (
            <div id={`printThis-${woundType}`} className="printDiv_content">
              <Grid className="registerTitle" container spacing={3}>
                <Grid item xs={4}>
                  <span className="font-weight-bolder">
                    Facility Name: {facilityName}
                  </span>
                </Grid>
                <Grid item xs={4}>
                  <span className="font-weight-bolder">Wound Report: </span>
                </Grid>
                <Grid item xs={4}>
                  <span className="font-weight-bolder">
                    {" "}
                    From: {GetDateString(fromDate)} To: {GetDateString(toDate)}{" "}
                  </span>
                </Grid>
              </Grid>

              <div className="mt-5 mb-7 woundType">
                <p className="mb-1 fs_1_1">
                  <span className="font-weight-bolder">Wound Type: </span>{" "}
                  {woundType}
                </p>
              </div>
              <div className="mt-5">
                <table className="table table-striped table-bordered w-100">
                  <thead className="thead-light">
                    <tr className="tableHeader">
                      <th width="9%">
                        <strong>Name</strong>
                      </th>
                      <th width="6%">
                        <strong>Unit/Room</strong>
                      </th>
                      <th width="9%">
                        <strong>Date First Observed</strong>
                      </th>
                      <th width="30%">
                        <div className="facility-report_content">
                          <div className="facility-report_rotate-text">
                            <strong>Admitted</strong>
                          </div>
                          <div className="facility-report_rotate-text">
                            <strong>Acquired</strong>
                          </div>
                          <div className="facility-report_rotate-text">
                            <strong>Closed</strong>
                          </div>
                          <div className="facility-report_rotate-text">
                            <strong>Reoccurring</strong>
                          </div>
                        </div>
                      </th>
                      <th width="9%">
                        <strong>Location</strong>
                      </th>
                      <th width="9%">
                        <strong>Type</strong>
                      </th>
                      <th width="1%">
                        <strong>Length</strong>
                      </th>
                      <th width="1%">
                        <strong>Width</strong>
                      </th>
                      <th width="1%">
                        <strong>Depth</strong>
                      </th>
                      <th width="1%">
                        <strong>
                          Stage/
                          <br />
                          Thickness
                        </strong>
                      </th>
                      <th width="1%">
                        <strong>Exudate</strong>
                      </th>
                      <th width="1%">
                        <strong>Push</strong>
                      </th>
                    </tr>
                    <tr className="tableHeader">
                      <th colSpan={4}>
                        <strong>
                          Wound bed Peri-wound Wound Edge Description
                        </strong>
                      </th>
                      <th colSpan={9}>
                        <strong>Treatment</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {woundEvaluationDetail.map((wound, index) => {
                      let exudateId = 0;
                      const exudateMap = {
                        Light: exudate.light,
                        Moderate: exudate.moderate,
                        Heavy: exudate.heavy,
                      };

                      const horizontalOrientation = getHorizontalOrientation(
                        wound.orientationLeftRight
                      );
                      exudateId = exudateMap[wound.exudateAmountName]
                        ? exudateMap[wound.exudateAmountName]
                        : 0;
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{wound.residentName}</td>
                            <td>{wound.roomUnit ? wound.roomUnit : "N/A"}</td>
                            <td>
                              {moment(wound.dateFirstObserved).format(
                                "YYYY-MM-DD"
                              )}
                            </td>
                            <td>
                              <div className="facility-report_count-content">
                                {wound.acquisition === acquisitionEnum[1] ? (
                                  <span>1</span>
                                ) : (
                                  <span>0</span>
                                )}
                                {wound.acquisition === acquisitionEnum[2] ? (
                                  <span>1</span>
                                ) : (
                                  <span>0</span>
                                )}
                                {wound.acquisition === acquisitionEnum[3] ? (
                                  <span>1</span>
                                ) : (
                                  <span>0</span>
                                )}
                                {wound.acquisition === acquisitionEnum[4] ? (
                                  <span>1</span>
                                ) : (
                                  <span>0</span>
                                )}
                              </div>
                            </td>
                            <td>
                              {horizontalOrientation}
                              {wound.woundBodyRegion} / {wound.woundLocation}
                            </td>
                            <td>{wound.woundType}</td>
                            <td>{wound.woundLength}</td>
                            <td>{wound.woundWidth}</td>
                            <td>{wound.woundDepth}</td>
                            <td>{wound.woundThicknessName}</td>
                            <td>{wound.exudateAmountName}</td>
                            <td>
                              {calculatePushScore(
                                wound.woundLength * wound.woundWidth,
                                exudateId,
                                wound.fkWoundSevereTissueTypeId
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td colSpan={3}>
                              {wound.granulationPerc > 0 && (
                                <p className="mb-0">
                                  <span>Granulation %:</span>
                                  {wound.granulationPerc}{" "}
                                </p>
                              )}
                              {wound.hyperGranulationPerc > 0 && (
                                <p className="mb-0">
                                  <span>HyperGranulation %:</span>
                                  {wound.hyperGranulationPerc}{" "}
                                </p>
                              )}
                              {wound.sloughPerc > 0 && (
                                <p className="mb-0">
                                  <span>Slough %:</span>
                                  {wound.sloughPerc}{" "}
                                </p>
                              )}
                              {wound.necroticPerc > 0 && (
                                <p className="mb-0">
                                  <span>Necrotic/Eschar %:</span>
                                  {wound.necroticPerc}{" "}
                                </p>
                              )}
                              {wound.epithelialPerc > 0 && (
                                <p className="mb-0">
                                  <span>Epithelial %:</span>
                                  {wound.epithelialPerc}{" "}
                                </p>
                              )}
                              {wound.musclePerc > 0 && (
                                <p className="mb-0">
                                  <span>Muscle, Tendon or Bone %:</span>
                                  {wound.musclePerc}{" "}
                                </p>
                              )}
                              {wound.otherPerc > 0 && (
                                <p className="mb-0">
                                  <span>{wound.otherWoundDesc} %:</span>
                                  {wound.otherPerc}{" "}
                                </p>
                              )}

                              <p className="mb-0">
                                <span>Surrounding Skin:</span>{" "}
                                {wound.wounSurroundingSkinName}
                              </p>
                              {wound.wounSurroundingSkinName === "Other" && (
                                <p className="mb-0">
                                  <span>Surrounding Skin Other:</span>{" "}
                                  {wound.otherSurroundingSkin}
                                </p>
                              )}
                              <p className="mb-0">
                                <span>Wound Edges:</span> {wound.woundEdgesName}
                              </p>
                            </td>
                            <td colSpan={8}>{wound.treatment}</td>
                          </tr>
                          <br />
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          );
        }
      )}
    </>
  );
};
